/**
 * This is an extension of the default kendo Pager.
 *
 * It sets our default options, such as messages text.
 *
 */
import locale from "common/managers/locale";

const DFPager = kendo.ui.Pager.extend({

    options: {

        name: "DFPager",

        //When true, the options will be configured to match what is needed in main
        defaultPaging: false,
        responsive: false

    },

    init: function(element, options) {

        var me = this,
            id = undefined;

        var el = $(element);
        if (el.attr("id") == undefined) {
            console.error("DFPager Widget widgets require an id");
        } else {
            id = el.attr("id");
        }

        if (options.defaultPaging) {
            options.input = true;
            options.numeric = false;
            options.messages = {
                display: locale.get('pager.total') + '{2}',
                itemsPerPage: locale.get('pager.itemsPerPage'),
                page: locale.get('pager.page'),
                empty: locale.get('pager.total') + '0'
            };
        } else {
            me.options.messages.empty = '0';
            me.options.messages.display = '{0} - {1} of {2}';
            me.options.numeric = false;
        }

        kendo.ui.Pager.fn.init.call(this, element, options);
        const adminStyle = !this.options.pageSizes && !this.options.numeric && !this.options.input && this.options.info && this.options.previousNext;
        this.element.toggleClass("adminStylePaging", adminStyle);
        this.wrapper = this.element;
    },

    refresh: function() {
        kendo.ui.Pager.fn.refresh.apply(this, arguments);

        if (this.dataSource.totalPages() > 1) {
            this.element.removeClass("onePage")
                .find(".k-pager-nav:not(.k-state-disabled)").removeAttr("tabindex");
        } else {
            this.element.addClass("onePage");
        }

        var page = this.element.find(".k-pager-input.k-label .k-textbox")
            .attr("type", "text")
            .attr("tabindex", "0")
            .attr("aria-label", locale.get("page"));
    },

    destroy: function() {
        kendo.ui.Pager.fn.destroy.call(this);
    }

});

kendo.ui.plugin(DFPager);
export default DFPager;
